import client from "./client";

export const doCheck = async (body) => (await client.post("/attendance/check", body)).data;
export const doCheckS3 = async (body) => (await client.post("/attendance/check-s3", body)).data;
export const fetchToday = async () => (await client.get("/attendance/today")).data;
export const fetchDayStatus = async (branch_id, date) =>
  (await client.get("/attendance/day-status", { params: { branch_id, date: date || undefined } })).data;
export const fetchHistory = async (days = 7) =>
  (await client.get("/attendance/me/history", { params: { days } })).data;
export const exportMyLog = async (days, format, lang) => {
  const res = await client.get("/attendance/me/export", {
    params: { days, format, lang },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `my-attendance.${format === "pdf" ? "pdf" : "xlsx"}`;
  link.click();
  URL.revokeObjectURL(url);
};
export const geoCheck = async (branch_id, latitude, longitude) =>
  (await client.get("/attendance/geo-check", { params: { branch_id, latitude, longitude } })).data;
export const fetchReadiness = async (branch_id, latitude, longitude, action, duty_id, qr_code) =>
  (await client.get("/attendance/readiness", {
    params: { branch_id, latitude, longitude, action, duty_id: duty_id || undefined, qr_code: qr_code || undefined },
  })).data;
